import View from "./View";

const List = () => <View />;

export default List;
